export type CommunityThemeKey = 'extremadura' | 'andalucia' | 'otra' | string;

export interface FuncionarioTheme {
  key: CommunityThemeKey;
  label: string;
  tagline: string;
  accent: string;
  accentSoft: string;
  accentText: string;
  chipClass: string;
  motifClass: string;
  heroClass: string;
}

const THEMES: Record<string, FuncionarioTheme> = {
  extremadura: {
    key: 'extremadura',
    label: 'Extremadura',
    tagline: 'Sobrio, institucional y con foco en la gestion municipal.',
    accent: '#1F7A5A',
    accentSoft: '#E7F5EE',
    accentText: '#0F5132',
    chipClass: 'border-emerald-200 bg-emerald-50 text-emerald-800',
    motifClass: 'bg-[radial-gradient(circle_at_20%_20%,rgba(31,122,90,0.18),transparent_0_26px)] bg-[length:36px_36px]',
    heroClass: 'from-emerald-50 via-white to-amber-50',
  },
  andalucia: {
    key: 'andalucia',
    label: 'Andalucia',
    tagline: 'Mas luminosa, cercana y muy limpia visualmente.',
    accent: '#116530',
    accentSoft: '#E9F7EF',
    accentText: '#0B3B1F',
    chipClass: 'border-lime-200 bg-lime-50 text-lime-800',
    motifClass: 'bg-[linear-gradient(135deg,rgba(17,101,48,0.10)_25%,transparent_25%,transparent_50%,rgba(17,101,48,0.10)_50%,rgba(17,101,48,0.10)_75%,transparent_75%,transparent)] bg-[length:18px_18px]',
    heroClass: 'from-lime-50 via-white to-amber-50',
  },
  otra: {
    key: 'otra',
    label: 'Perfil general',
    tagline: 'Base neutra preparada para personalizar por comunidad.',
    accent: '#002B5B',
    accentSoft: '#EAF0F8',
    accentText: '#002B5B',
    chipClass: 'border-slate-200 bg-slate-50 text-slate-700',
    motifClass: 'bg-[radial-gradient(circle_at_20%_20%,rgba(0,43,91,0.10),transparent_0_24px)] bg-[length:34px_34px]',
    heroClass: 'from-slate-50 via-white to-cyan-50',
  },
};

export function getFuncionarioTheme(community?: string | null): FuncionarioTheme {
  const key = (community || 'otra').toLowerCase();
  return THEMES[key] || THEMES.otra;
}

export function getCommunityLabel(community?: string | null): string {
  if (community === 'andalucia') return 'Andalucia';
  if (community === 'extremadura') return 'Extremadura';
  return 'Perfil general';
}
